import styled from "styled-components";

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const SequenceDetailsCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;
